import { Button } from '@client/components/ui/button';
import { LtcFinancialPlanningNavigation } from '@client/hooks/useLtcFinancialPlanningNavigation';
import { cn } from '@client/lib';
import { ChevronRight } from 'lucide-react';

export default function BottomNavigation(props: {
  navigation: LtcFinancialPlanningNavigation;
  onContinue: () => void;
  canContinue: boolean;
  onBack?: () => void;
}) {
  const { navigation, onContinue, canContinue, onBack } = props;
  const NAV_BUTTON_STYLE = cn(
    'max-h-16 md:min-w-32 rounded-full px-6 py-4 text-base text-white md:px-8 md:py-6 md:text-lg bg-primary hover:bg-primary-hover m-0',
  );

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[10] flex w-full justify-center md:left-0 md:right-0">
      <div
        className={cn(
          'flex w-full flex-row items-end justify-center gap-4 bg-white p-4 shadow-[0_-2px_4px_rgba(0,0,0,0.1)] md:mb-8 md:w-fit md:rounded-full md:shadow-lg',
        )}
      >
        {navigation.canGoPrev && (
          <Button
            variant="outline"
            onClick={onBack || navigation.goPrev}
            className={cn(NAV_BUTTON_STYLE, 'bg-white text-gray-800 hover:bg-gray-100')}
          >
            Back
          </Button>
        )}

        {navigation.currentStep !== 'complete' && (
          <Button
            onClick={onContinue}
            className={cn(NAV_BUTTON_STYLE, 'text-white', !canContinue ? 'cursor-not-allowed' : '')}
            disabled={!canContinue}
          >
            <div className="flex items-center gap-1">
              Continue
              <ChevronRight className="h-6 w-6" />
            </div>
          </Button>
        )}
      </div>
    </div>
  );
}
